import { USER_OBTAINED_NO_SESSION, USER_OBTAINED_SESSION } from './check-authentication.constants';
import { Dispatch } from 'types/dispatch';

export const goToGetBetaInfo = () => (dispatch: Dispatch): void => {
    dispatch({
        type: USER_OBTAINED_SESSION
    });
};

export const goToLandingPage = () => (dispatch: Dispatch): void => {
    dispatch({
        type: USER_OBTAINED_NO_SESSION
    });
};
